export default __webpack_public_path__ + "static/media/shedule1.6dd382e6.png";